<template>
	<v-dialog v-model="dialog" persistent max-width="700">
		<v-card flat class=" pa-40 textAlignCenter" style="background-color:white !important">
			<h2>{{mflTitle[selectedMfl]}}.</h2>
			<br>
			<table class="mflTable">
				<thead>
					<tr>
						<th>Nivel de<br>severidad</th>
						<th>Descripción</th>
						<th>Factor de<br>severidad</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(v, i) in rows"
						:key="i"
						@click="set(v[0])"
						:class="getClass(v[0])">
						<td>{{v[0]}}</td>
						<td>{{v[1]}}</td>
						<td>{{v[2]}}</td>
					</tr>
				</tbody>
			</table>
			<br>
			<v-btn color="secondary" @click="close()">
				<v-icon></v-icon>
				<span>Cerrar</span>
			</v-btn>
		</v-card>
	</v-dialog>
</template>

<script>
import { mflTitle } from '@/objects/general.js';
const severityFactor = [0,1,3,10,30,100,300,1000];
export default {
	props:{
		dialog: {},
		item: {},
		selectedMfl: {},
		edit: { default: true}
	},
  data() {
		const mfls = {
			mfl_health_and_safety: [
				[7,'>50 muertes. Discapacidad permanente de >30% del cuerpo en más de 500 personas.',severityFactor[7]],
				[6,'>20 muertes. Discapacidad permanente en >30% del cuerpo de más de 100 personas.',severityFactor[6]],
				[5,'2-20 muertes. Discapacidad permanente de >30% del cuerpo en más de 10 personas.',severityFactor[5]],
				[4,'Una muerte. Discapacidad permanente en >30% del cuerpo de una o más personas.',severityFactor[4]],
				[3,'Discapacidad permanente en <30% del cuerpo de una o más personas. Restricción o pérdida de días por motivo de lesión o enfermedad.',severityFactor[3]],
				[2,'Discapacidad objetiva pero reversible.  Tratamiento médico por lesión o enfermedad.',severityFactor[2]],
				[1,'Síntomas o inconvenientes subjetivos de bajo nivel y a corto plazo.  Sin tratamiento médico.',severityFactor[1]],
				[0,'No aplica.',severityFactor[0]],
			],
			mfl_environment: [
				[7,'Uno o más impactos severos permanentes a la tierra, biodiversidad, servicios del ecosistema, recursos hídricos o aire.',severityFactor[7]],
				[6,'Uno o más impactos severos (>20 años) a la tierra, biodiversidad, servicios del ecosistema, recursos hídricos o aire.',severityFactor[6]],
				[5,'Uno o más impactos graves o extensos (<20 años) a la tierra, biodiversidad, servicios del ecosistema, recursos hídricos o aire.',severityFactor[5]],
				[4,'Impacto(s) mayor(es)  (<5 años) a la tierra, biodiversidad, servicios del ecosistema, recursos hídricos o aire.',severityFactor[4]],
				[3,'Impacto(s) moderado(s)  (<1 años) a la tierra, biodiversidad, servicios del ecosistema, recursos hídricos o aire.',severityFactor[3]],
				[2,'Impacto(s) menor(es) (<3 meses) a la tierra, biodiversidad, servicios del ecosistema, recursos hídricos o aire.',severityFactor[2]],
				[1,'Uno o más impactos de bajo nivel a la tierra, biodiversidad, servicios del ecosistema, recursos hídricos o aire.',severityFactor[1]],
				[0,'No aplica.',severityFactor[0]],
			],
			mfl_community: [
				[7,'Impactos severos y generalizados a la salud, seguridad o protección de la comunidad (>1000 hogares) o violaciones a los derechos humanos; destrucción total de >1000 hogares o infraestructuras comunitarias; profanación total irreversible de múltiples estructuras, objetos o lugares de importancia mundial.',severityFactor[7]],
				[6,'Impactos extensos a la salud, seguridad o protección de la comunidad (>200 hogares) o violaciones a los derechos humanos; perturbación grave y prolongada a la vida de las personas (>1000 hogares); daños extensos a >1000 hogares o infraestructuras o estructuras comunitarias, objetos o lugares de importancia cultural mundial.',severityFactor[6]],
				[5,'Impactos graves a la salud, seguridad o protección de la comunidad (>50 hogares) o violaciones a los derechos humanos; perturbación prolongada a la vida de las personas (>200 hogares); daños extensos a >200 hogares o estructuras comunitarias, objetos o lugares de importancia cultural nacional.',severityFactor[5]],
				[4,'Impactos graves a la comunidad en materias de salud, seguridad o protección (<50 hogares). Múltiples denuncias de violaciones a los derechos humanos; perturbación prolongada a la vida de las personas (>50 hogares); daños extensos a >50 hogares; daño irreversible moderado a estructuras, objetos o lugares de importancia cultural nacional.',severityFactor[4]],
				[3,'Impactos moderados a la comunidad en materias de salud, seguridad o protección (<50 hogares). Una denuncia de violación a los derechos humanos; perturbación moderada a la vida de las personas (<50 hogares); daños extensos a <50 hogares; daño reversible moderado a estructuras, objetos o lugares de importancia cultural nacional.',severityFactor[3]],
				[2,'Impacto(s) menor(es) a la comunidad en materias de salud, seguridad y protección (<10 hogares) o vulneraciones a los derechos humanos; inconvenientes a medios de sustento <50 hogares o infraestructura comunitaria; daños menores reversibles a estructuras, objetos o lugares de importancia cultural regional.',severityFactor[2]],
				[1,'Impacto único de bajo nivel a la comunidad en materias de salud, seguridad y protección; inconveniente de bajo nivel <2 semanas; molestia o daño menor reversible de bajo nivel a un solo hogar o estructura, objeto o lugar de importancia cultural regional.',severityFactor[1]],
				[0,'No aplica.',severityFactor[0]],
			],
			mfl_legal: [
				[7,'Quiebra que afecte al Negocio o múltiples Assets. No otorgamiento o pérdida del derecho legal de desarrollar u operar el Negocio o múltiples Assets. Investigación2 por supuesto incumplimiento normativo, delito o violación al derecho internacional severo con impacto de largo plazo para toda la compañía. Ser demandado en uno o más procesos civiles de alto perfil con impacto de largo plazo para toda la compañía.',severityFactor[7]],
				[6,'La quiebra que afecte a un Asset. No otorgamiento o pérdida del derecho legal de desarrollar u operar un Asset.  Investigación2 por supuesto incumplimiento normativo, delito o violación severa al derecho internacional. Demanda en contra en múltiples procesos civiles de alto perfil.',severityFactor[6]],
				[5,'Impedimento del derecho legal de desarrollar u operar un Asset. Investigación2 por supuesto incumplimiento normativo, delito o violación al derecho internacional de alto perfil. Un supuesto incumplimiento de leyes relacionadas con el cumplimiento se considerará un incumplimiento normativo de alto perfil. Demanda en contra en un proceso civil de alto perfil. Investigación pública a BHP o sobre un asunto crítico para la industria de recursos naturales.',severityFactor[5]],
				[4,'Investigación2 por supuesto incumplimiento normativo mayor. Demanda en contra en un proceso civil mayor.',severityFactor[4]],
				[3,'Asunto legal solucionable con consecuencias moderadas. Pérdida o no obtención del derecho legal de desarrollar u operar (o aprobación de) una actividad no principal.',severityFactor[3]],
				[2,'Asunto legal solucionable con consecuencias menores.',severityFactor[2]],
				[1,'Asunto legal de bajo nivel solucionable sin procesos jurídicos o participación sustantiva de terceros.',severityFactor[1]],
				[0,'No aplica.',severityFactor[0]],
			],
			mfl_reputation: [
				[7,'Evento de crisis o publicación de información privilegiada altamente confidencial que resulten en campañas internacionales de los medios de comunicación, gobiernos, entes reguladores u ONG y condena por parte de los empleados de la compañía (>6 meses). Daño de largo plazo a la reputación de la compañía.',severityFactor[7]],
				[6,'Evento de crisis o publicación de información privilegiada confidencial que resulten en campañas internacionales de los medios de comunicación, gobiernos, entes reguladores u ONG y condena por parte de los empleados de la compañía (<6 meses). La condena continua resulta en daños a la reputación de la compañía.',severityFactor[6]],
				[5,'Cobertura negativa grave en medios de comunicaciones nacionales e internacionales. Reacción adversa del público en general y ONG con interés de los entes reguladores (< 3 meses). Campañas estructuradas por empleados, ONG o comunidades con un impacto significativo sobre la reputación del Negocio o Asset.',severityFactor[5]],
				[4,'Cobertura adversa en los medios de comunicación nacionales. Reacción adversa del público en general y ONG con interés por parte de entes reguladores sin resultados materiales. Campañas estructuradas por empleados, ONG o comunidades con un impacto significativo sobre la reputación del Negocio o Asset.',severityFactor[4]],
				[3,'Cobertura por los medios de comunicación regionales o elevada preocupación en la comunidad local. Críticas por parte de la comunidad, ONG o activistas. Efecto adverso en la reputación del Asset.',severityFactor[3]],
				[2,'Opinión pública local desfavorable o cobertura adversa en los medios de comunicación locales y quejas. Mayor escrutinio por parte de los entes reguladores. La reputación del Asset se ve afectada adversamente ante un número pequeño de gente.',severityFactor[2]],
				[1,'Preocupación pública limitada a quejas locales. Interés de bajo nivel por parte de los medios de comunicación local o entes reguladores.',severityFactor[1]],
				[0,'No tiene impacto en la reputación de la compañia.',severityFactor[0]],
			],
			mfl_financial: [
				[7,'≥ US$2,5 billones (participación de BHP)',severityFactor[7]],
				[6,'≥ US$1 billón a <US$2,5 billones (Participación de BHP)',severityFactor[6]],
				[5,'≥ US$250 millones a <US$1 billón (Participación de BHP)',severityFactor[5]],
				[4,'≥ US$25 millones a <US$250 millones (Participación de BHP)',severityFactor[4]],
				[3,'≥ US$2,5 millones a < US$25 millones (Participación de BHP)',severityFactor[3]],
				[2,'≥US$250.000 a <US$2,5 millones (Participación de BHP)',severityFactor[2]],
				[1,'<U$250.000 (Participación de BHP)',severityFactor[1]],
			],
		}

		mfls.health_and_safety_residual = mfls.mfl_health_and_safety;
		mfls.environment_residual = mfls.mfl_environment;
		mfls.community_residual = mfls.mfl_community;
		mfls.legal_residual = mfls.mfl_legal;
		mfls.reputation_residual = mfls.mfl_reputation;
		mfls.financial_residual = mfls.mfl_financial;

    return {
      mflTitle,
			mfls,
			checkResidual: {
				health_and_safety_residual: 'mfl_health_and_safety',
				environment_residual: 'mfl_environment',
				community_residual: 'mfl_community',
				legal_residual: 'mfl_legal',
				reputation_residual: 'mfl_reputation',
			},
    };
	},
	created() { },
  watch: { },
  computed: {
		rows() { return this.mfls[this.selectedMfl] }
  },
  methods: {
		canSet(v) {
			const toCheck = this.checkResidual[this.selectedMfl];
			if (!toCheck) return true;
			return v <= this.item[toCheck];
		},
		getClass(v){
			if (this.item[this.selectedMfl] === v) return 'selected';
			if (!this.canSet(v)) return 'disabled';
			return '';
		},
		set(v) {
			if (this.edit === false)  return;
			if (!this.canSet(v)) {
				const toCheck = this.checkResidual[this.selectedMfl];
				this.setSnackbar({
					message: `${this.mflTitle[this.selectedMfl]} no puede ser mayor que ${this.mflTitle[toCheck]}.`,
					class: 'error',
					timeout: 6000,
					'multi-line': true,
					clearable: true,
				})
				return;
			}
			if (!['mfl_financial', 'financial_residual'].includes(this.selectedMfl)) {
				this.item[this.selectedMfl] = v;
			}
			this.close();
		},
		close() { this.$emit('update:dialog', false) },
  },
};
</script>